/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectConditionContentResponse
 */
export interface ProjectConditionContentResponse {
    /**
     * HTML content of the project condition
     * @type {string}
     * @memberof ProjectConditionContentResponse
     */
    content: string;
}

/**
 * Check if a given object implements the ProjectConditionContentResponse interface.
 */
export function instanceOfProjectConditionContentResponse(value: object): value is ProjectConditionContentResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ProjectConditionContentResponseFromJSON(json: any): ProjectConditionContentResponse {
    return ProjectConditionContentResponseFromJSONTyped(json, false);
}

export function ProjectConditionContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectConditionContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ProjectConditionContentResponseToJSON(value?: ProjectConditionContentResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
    };
}

